import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import TableHeaders from "./TableHeaders";
import TableBody from "./TableBody";
import TableControls from "./TableControls";
import { withRouter } from "react-router";

const OrderItemsTable = ({ history, items }) => {
  const col = [
    {
      Header: "ID",
      accessor: "id",
      columnType: "col-sm-1",
    },
    {
      Header: "ISBN",
      accessor: "format.isbn",
      columnType: "col-sm-1",
    },
    {
      Header: "Tytuł",
      accessor: "format.product.title", // Access the nested title directly
      columnType: "col-sm-2",
    },
    {
      Header: "Autor",
      accessor: "format.product.authors", // Access the nested title directly
      columnType: "col-sm-2",
      Cell: ({ value }) => {
        // Check if value exists and is an array
        if (!value || !Array.isArray(value)) {
          return "";
        }

        // Filter authors to get only those with role "author"
        const authors = value
          .filter(author => author.role === "author")
          .map(author => author.name);

        // Join multiple authors with commas, or return "N/A" if none found
        return authors.length > 0 ? authors.join(", ") : "N/A";
      }
    },

    {
      Header: "Format",
      accessor: "formatType",
      columnType: "col-sm-1",
    },

    {
      Header: "Ilość",
      accessor: "quantity",
      columnType: "col-sm-1",

    },
    {
      Header: "Cena jedn.",
      accessor: "unitPrice",
      columnType: "col-sm-1",
      Cell: ({ value }) => {
        if (value === null || value === undefined) {
          return "N/A";
        }
        return `${(value / 100).toFixed(2)} zł`;
      },
    },
    {
      Header: "Wartość",
      accessor: "totalPrice",
      columnType: "col-sm-1",
      Cell: ({ value }) => {
        if (value === null || value === undefined) {
          return "N/A";
        }
        return `${(value / 100).toFixed(2)} zł`;
      },
    },
    {
      Header: "st. VAT",
      accessor: "vatRate",
      columnType: "col-sm-1",
      Cell: ({ value }) => {
        if (value === null || value === undefined) {
          return "N/A";
        }
        return `${value.toFixed(2)} %`;
      }
    }
  ];

  useEffect(() => {

  }, []);

  const columns = useMemo(() => col, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    pageOptions,
    state,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    prepareRow,
    gotoPage,
    pageCount,
  } = useTable(
    { columns, data: items, initialState: { pageSize: 14 }, autoResetSortBy: false },
    useSortBy,
    usePagination
  );
  const { pageIndex } = state;


  return (
    <div
      className="container"
      {...getTableProps()}
      style={{ maxWidth: "100%", maxHeight: "100%" }}
    >
      {
        <>
          <TableHeaders headerGroups={headerGroups} />
          <TableBody
            {...getTableBodyProps()}
            rows={page}
            prepareRow={prepareRow}
            onClick={() => { }}
            maxHeight={"67vh"}
          />
          <TableControls
            pageOptions={pageOptions}
            nextPage={nextPage}
            previousPage={previousPage}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            pageIndex={pageIndex}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
        </>

      }
    </div>
  );
};

export default withRouter(OrderItemsTable);
